import { createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "modal-mask" }, [
  /*#__PURE__*/_createVNode("div", { class: "modal-wrapper" }, [
    /*#__PURE__*/_createVNode("div", {
      class: "modal-dialog",
      role: "document"
    }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_0,
        class: "logo",
        id: "animated_div",
        alt: "logo"
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loader)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_Transition, { name: "modal" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layout)))
  ]))
}